var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        [
          _c("sui-container", [
            _c("div", { staticClass: "manager-header" }, [
              _c("div", { staticClass: "title" }, [
                _c("span", [_c("h2", [_vm._v("Staff Directory")])]),
              ]),
              _c(
                "div",
                { staticClass: "search-filter" },
                [
                  _c("sui-input", {
                    attrs: {
                      placeholder: "Search directory...",
                      icon: "search",
                      "icon-position": "left",
                    },
                    model: {
                      value: _vm.searchPhrase,
                      callback: function ($$v) {
                        _vm.searchPhrase =
                          typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "searchPhrase",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "sui-container",
        [
          _c("StaffList", {
            attrs: { staff: _vm.staff },
            on: {
              getStaffMember: _vm.getStaffMember,
              toggleModal: _vm.toggleModal,
              showDeleteAlert: _vm.showDeleteAlert,
            },
          }),
          _c("StaffModal", {
            attrs: {
              isOpen: _vm.isOpen,
              isNew: _vm.isNew,
              staffMember: _vm.staffMember,
              "toggle-modal": _vm.toggleModal,
              "reset-is-new": _vm.resetIsNew,
            },
          }),
          _c("DeleteAlert", {
            ref: "deleteAlert",
            on: { handleDelete: _vm.deleteStaffMember },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }